module.exports = __webpack_public_path__ + "img/Img8_204726_BjEr-1-1.73962585.jpg";